import { createRouter, createWebHistory } from "vue-router";

import ApiAccessSettings from "@/components/settings/apiAccess";
import BlacklistIpsSettings from "@/components/settings/blacklistIps";
import BotDelaysSettings from "@/components/settings/botDelays";
import ContextFiltersSettings from "@/components/settings/contextFilters";
import ConversationsSettings from "@/components/settings/conversations";
import EventTrackingSettings from "@/components/settings/eventTracking";
import EventTrackingGA4Settings from "@/components/settings/eventTrackingGA4";
import InitialMessageSettings from "@/components/settings/initialMessage";
import MatcherThresholdsSettings from "@/components/settings/matcherThresholds";
import NotificationSettings from "@/components/settings/notifications";
import ParamCampaignSettings from "@/components/settings/paramCampaign";
import QueryOverridesSettings from "@/components/settings/queryOverrides";
import WebhooksSettings from "@/components/settings/webhooks";
import WidgetSettings from "@/components/settings/widget";
import Categories from "@/pages/categories/index";
import Category from "@/pages/categories/show";
import Conversations from "@/pages/conversations";
import Dashboard from "@/pages/dashboard";
import Dealerships from "@/pages/dealerships/index";
import DealershipNew from "@/pages/dealerships/new";
import DealershipShow from "@/pages/dealerships/show";
import Home from "@/pages/home";
import Integrations from "@/pages/integrations/index";
import QueriesIndex from "@/pages/queries/index";
import QueriesNew from "@/pages/queries/new";
import QueriesShow from "@/pages/queries/show";
import Reports from "@/pages/reports/index";
import Settings from "@/pages/settings";
import SignIn from "@/pages/sign-in";
import Teams from "@/pages/teams";
import Training from "@/pages/training";
import Webhooks from "@/pages/webhooks";
import WrongCfgEventsIndex from "@/pages/wrongcfgevents/index";

const routes = [
  { path: "/", component: Home },
  { path: "/sign-in", component: SignIn },
  { path: "/dashboard", component: Dashboard },
  { path: "/categories", component: Categories },
  { path: "/categories/:id", component: Category },
  { path: "/conversations", component: Conversations },
  { path: "/conversations/:id", component: Conversations },
  { path: "/training", component: Training },
  { path: "/queries", component: QueriesIndex },
  { path: "/queries/new", component: QueriesNew },
  { path: "/queries/:id", component: QueriesShow },
  { path: "/teams", component: Teams },
  { path: "/integrations", component: Integrations },
  { path: "/dealerships", component: Dealerships },
  { path: "/dealerships/new", component: DealershipNew },
  { path: "/dealerships/:id", component: DealershipShow },
  { path: "/webhooks", component: Webhooks },
  { path: "/reports", component: Reports },
  { path: "/wrongcfgevents", component: WrongCfgEventsIndex },
  {
    path: "/settings",
    component: Settings,
    children: [
      { path: "widget", component: WidgetSettings },
      { path: "conversations", component: ConversationsSettings },
      { path: "initial-message", component: InitialMessageSettings },
      { path: "query-overrides", component: QueryOverridesSettings },
      { path: "bot-delays", component: BotDelaysSettings },
      { path: "webhooks", component: WebhooksSettings },
      { path: "matcher-thresholds", component: MatcherThresholdsSettings },
      { path: "context-filters", component: ContextFiltersSettings },
      { path: "blacklist-ips", component: BlacklistIpsSettings },
      { path: "api-access", component: ApiAccessSettings },
      { path: "campaign", component: ParamCampaignSettings },
      { path: "event-tracking", component: EventTrackingSettings },
      { path: "event-trackingGA4", component: EventTrackingGA4Settings },
      { path: "notifications", component: NotificationSettings }
    ]
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;

